import { __decorate } from "tslib";
import { Component, ElementRef, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { ComponentService } from './shared/services/component.service';
import { NavigationEnd, Router } from '@angular/router';
import { WebClientService } from './shared/services/webclient-settings.service';
import { LanguageService } from './shared/services/language.service';
import { EcurrenciesService } from './shared/services/ecurrencies.service';
import { WebsiteThemeService } from './shared/services/website-theme.service';
import { AuthService } from './shared/services/auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import { GoogleAnalyticsService } from './shared/services/google-analytics.service';
import { Location } from '@angular/common';
import { DocumentInterruptSource, Idle, StorageInterruptSource } from "@ng-idle/core";
import { Keepalive } from "@ng-idle/keepalive";
import SmartBanner from 'smartbanner.js/src/smartbanner.js';
let AppComponent = class AppComponent {
    constructor(viewContainerRef, router, webSettingsService, languageService, ecurrenciesService, themeService, elementRef, auth, sanitizer, googleAnalyticsService, location, idle, keepalive) {
        this.viewContainerRef = viewContainerRef;
        this.router = router;
        this.webSettingsService = webSettingsService;
        this.languageService = languageService;
        this.ecurrenciesService = ecurrenciesService;
        this.themeService = themeService;
        this.elementRef = elementRef;
        this.auth = auth;
        this.sanitizer = sanitizer;
        this.googleAnalyticsService = googleAnalyticsService;
        this.location = location;
        this.idle = idle;
        this.keepalive = keepalive;
        this.language = '';
        this.currentRoute = '';
        this.spinnerOn = true;
        this.allLangs = [];
        this.error = false;
        this.backgroundImage = '';
        this.ecurrenciesError = false;
        this.user = {};
        this.loggedIn = false;
        this.lastPing = null;
        this.zendeskHelpLoading = false;
        this.countdown = 0;
        this.showSessionExpirationModal = false;
        ComponentService.setViewContainerRef(viewContainerRef);
        this.zendeskHelpLoading = this.isHelpRoute();
        this.language = localStorage.getItem('language');
        this.user = JSON.parse(localStorage.getItem('user'));
        this.auth.getStatus().subscribe((result) => {
            this.loggedIn = result;
            if (result) {
                this.setIdleExpirationCounter();
            }
        });
        // this.router.events.subscribe(event => {
        //     const ga = window[window['GoogleAnalyticsObject'] || 'ga'];
        //     if (event instanceof NavigationEnd && typeof ga === 'function') {
        //         (<any>window).ga('set', 'page', event.urlAfterRedirects);
        //         (<any>window).ga('send', 'pageview');
        //     }
        // });
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.handleZendeskHelpRoute();
                this.user = JSON.parse(localStorage.getItem('user'));
                if (this.user) {
                    let userType;
                    let userClass;
                    if (this.user.personally_validated) {
                        userType = 'verified';
                    }
                    else {
                        userType = 'registered';
                    }
                    if (this.user.user_type_id) {
                        userClass = this.user.user_type_id.name;
                    }
                    this.googleAnalyticsService.pushGAEvents([{
                            userType: userType,
                            userClass: userClass
                        }]);
                }
                else {
                    this.googleAnalyticsService.pushGAEvents([{
                            userType: 'guest'
                        }]);
                }
            }
        });
        this.themeService.getTheme().subscribe((data) => {
            this.backgroundImage = this.themeService.getStyleAttribute('background_image') + '';
            this.elementRef.nativeElement.ownerDocument.body.style.color = this.themeService.getStyleAttribute('text_color');
            const smartBanner = new SmartBanner();
            smartBanner.publish();
            const smartBannerElement = document.querySelector('.smartbanner');
            if (smartBannerElement) {
                this.mainContent.nativeElement.style.paddingTop = '84px';
            }
            const exitButton = document.querySelector('.js_smartbanner__exit');
            if (exitButton) {
                exitButton.addEventListener('click', (event) => this.mainContent.nativeElement.style.paddingTop = '0px');
            }
        });
    }
    ngOnInit() {
        if (this.user) {
            this.auth.extendUserSession(localStorage.getItem('expiry_date'));
        }
        this.webSettingsService.value.subscribe(val => {
            if (val) {
                this.spinnerOn = val;
            }
            this.error = val;
        });
        this.themeService.value.subscribe(value => {
            if (value) {
                this.spinnerOn = value;
            }
            this.error = value;
        });
        this.router.events.subscribe((change) => {
            if (change instanceof NavigationEnd) {
                this.ecurrenciesService.getEcurrencies().then((resolved) => {
                    if (!resolved) {
                        this.spinnerOn = true;
                        this.ecurrenciesError = true;
                    }
                });
            }
        });
        this.webSettingsService.getSettings().subscribe(data => {
            this.allLangs = this.languageService.getAvailableLanguages();
            this.currentRoute = window.location.pathname;
            this.webSettingsService.redirectToHome(this.currentRoute);
            this.spinnerOn = false;
        });
    }
    handleZendeskHelpRoute() {
        this.zendeskHelpLoading = this.isHelpRoute();
        if (this.zendeskHelpLoading) {
            this.openZendeskWidget();
        }
    }
    openZendeskWidget() {
        this.withZendesk((zE) => {
            if (!this.isHelpRoute()) {
                return;
            }
            zE('webWidget', 'open');
            this.waitForZendeskWidget();
        }, () => {
            this.zendeskHelpLoading = false;
        });
    }
    waitForZendeskWidget(attemptsLeft = 80) {
        const widget = document.getElementById('webWidget');
        if (widget) {
            const style = window.getComputedStyle(widget);
            if (style.opacity === '1' && style.visibility !== 'hidden') {
                this.zendeskHelpLoading = false;
                return;
            }
        }
        if (attemptsLeft > 0 && this.isHelpRoute()) {
            setTimeout(() => this.waitForZendeskWidget(attemptsLeft - 1), 250);
        }
        else {
            this.zendeskHelpLoading = false;
        }
    }
    isHelpRoute() {
        return this.location.path().split('?')[0] === '/help';
    }
    withZendesk(callback, onFail, attemptsLeft = 60) {
        const zE = window.zE;
        if (typeof zE === 'function') {
            callback(zE);
            return;
        }
        if (attemptsLeft > 0) {
            setTimeout(() => this.withZendesk(callback, onFail, attemptsLeft - 1), 250);
        }
        else if (onFail) {
            onFail();
        }
    }
    setIdleExpirationCounter() {
        const idleDuration = localStorage.getItem('token_duration') ? localStorage.getItem('token_duration') : 20;
        this.idle.setIdle((Number(idleDuration) * 60) - 75);
        this.idle.setTimeout(75);
        this.idle.setInterrupts(this.createCustomInterruptSources(null));
        this.idle.onTimeout.subscribe(() => {
            this.showSessionExpirationModal = false;
            this.auth.logOut(true);
        });
        this.idle.onTimeoutWarning.subscribe((countdown) => {
            this.countdown = countdown;
        });
        this.idle.onIdleStart.subscribe(() => {
            this.idle.clearInterrupts();
            this.showSessionExpirationModal = true;
        });
        this.keepalive.interval(15);
        this.keepalive.onPing.subscribe(() => this.lastPing = new Date());
        this.auth.getStatus().subscribe(userLoggedIn => {
            if (userLoggedIn) {
                this.idle.watch();
            }
            else {
                this.idle.stop();
            }
        });
    }
    createCustomInterruptSources(options) {
        return [
            new DocumentInterruptSource('keydown mousedown touchstart touchmove scroll mousewheel wheel', options),
            new StorageInterruptSource(options)
        ];
    }
    reset() {
        this.idle.watch();
        this.idle.setInterrupts(this.createCustomInterruptSources(null));
        this.showSessionExpirationModal = false;
    }
    logout() {
        this.idle.stop();
        this.showSessionExpirationModal = false;
        this.auth.logOut(true);
    }
};
AppComponent.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: Router },
    { type: WebClientService },
    { type: LanguageService },
    { type: EcurrenciesService },
    { type: WebsiteThemeService },
    { type: ElementRef },
    { type: AuthService },
    { type: DomSanitizer },
    { type: GoogleAnalyticsService },
    { type: Location },
    { type: Idle },
    { type: Keepalive }
];
__decorate([
    ViewChild('main')
], AppComponent.prototype, "mainContent", void 0);
AppComponent = __decorate([
    Component({
        selector: 'app-root',
        template: __importDefault(require("./app.component.html")).default,
        encapsulation: ViewEncapsulation.None
    })
], AppComponent);
export { AppComponent };
